var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.375C17.3125 6.5 17.625 7.5 17.0312 8.09375L13.75 11.3125L14.5312 15.8438C14.6562 16.6562 13.7812 17.2812 13.0625 16.9062L9 14.75L4.90625 16.9062C4.1875 17.2812 3.3125 16.6562 3.4375 15.8438L4.21875 11.3125L0.9375 8.09375C0.34375 7.5 0.65625 6.5 1.46875 6.375L6.0625 5.71875L8.09375 1.5625C8.46875 0.8125 9.53125 0.84375 9.875 1.5625L11.9375 5.71875L16.5 6.375ZM12.125 10.7812L15.2812 7.71875L10.9375 7.09375L9 3.15625L7.03125 7.09375L2.6875 7.71875L5.84375 10.7812L5.09375 15.0938L9 13.0625L12.875 15.0938L12.125 10.7812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a5bbaf34ea52c17cba5ece2b0b62a155.svg";
export { ForwardRef as ReactComponent };